export function jobStatusClass(status: string | null | undefined): string {
  switch (status) {
    case 'Unassigned':
      return 'job-status status-unassigned';
    case 'Scheduled':
      return 'job-status status-scheduled';
    case 'In Progress':
      return 'job-status status-active';
    case 'Paused':
      return 'job-status status-paused';
    case 'Quote Sent':
      return 'job-status status-quote';
    case 'Approved':
      return 'job-status status-approved';
    case 'Ready for Office':
      return 'job-status status-ready';
    case 'Completed':
      return 'job-status status-completed';
    case 'Terminated':
      return 'job-status status-error';
    default:
      return 'job-status status-processing';
  }
}

export function jobStatusTextClass(status: string | null | undefined): string {
  switch (status) {
    case 'Unassigned':
      return 'text-red-600';
    case 'Scheduled':
      return 'text-amber-600';
    case 'In Progress':
    case 'Completed':
      return 'text-emerald-600';
    case 'Paused':
    case 'Quote Sent':
      return 'text-orange-600';
    case 'Approved':
      return 'text-cyan-700';
    case 'Ready for Office':
      return 'text-slate-600';
    case 'Terminated':
      return 'text-red-600';
    default:
      return 'text-slate-400';
  }
}
